var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-tabs",
    {
      ref: "tabs",
      class: "sb-tabs " + _vm.tabsClass,
      attrs: {
        "slider-color": "accent",
        "show-arrows": _vm.showArrows,
        "active-class": "sb-tab-active",
        grow: ""
      },
      model: {
        value: _vm.activeTab,
        callback: function($$v) {
          _vm.activeTab = $$v
        },
        expression: "activeTab"
      }
    },
    [
      _vm._t("tabs-title"),
      _vm._v(" "),
      _vm.tabsClass === "sb-vertical-tabs"
        ? [
            _c("vuescroll", { ref: "vs", attrs: { ops: _vm.ops } }, [
              _c(
                "div",
                { staticClass: "sb_tabs_sidebar_list" },
                _vm._l(_vm.tabs, function(tab, idx) {
                  return _c(
                    "v-tab",
                    {
                      key: "tab-" + idx,
                      attrs: {
                        id:
                          _vm.removeSpecialCharacters(
                            tab.name || tab.title || tab.Nickname
                          ) + "_tab",
                        ripple: ""
                      }
                    },
                    [
                      _vm._t("title", [_vm._v(" No title provided ")], {
                        tab: tab
                      })
                    ],
                    2
                  )
                }),
                1
              )
            ])
          ]
        : _c(
            "div",
            { staticClass: "sb_tabs_sidebar_list" },
            [
              _vm._l(_vm.tabs, function(tab, idx) {
                return _c(
                  "v-tab",
                  {
                    key: "tab-" + idx,
                    attrs: {
                      id:
                        _vm.removeSpecialCharacters(
                          tab.name || tab.title || tab.Nickname
                        ) + "_tab",
                      ripple: ""
                    }
                  },
                  [
                    _vm._t("title", [_vm._v(" No title provided ")], {
                      tab: tab
                    })
                  ],
                  2
                )
              }),
              _vm._v(" "),
              _vm._t("action")
            ],
            2
          ),
      _vm._v(" "),
      _vm.showWarning
        ? _c(
            "v-tab-item",
            {
              key: "tab-item-" + _vm.tabs.length,
              staticClass: "no_list_warning px-2 py-2"
            },
            [_c("strong", [_vm._v(_vm._s(_vm.warningMessage))])]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.tabs, function(tab, idx) {
        return _c(
          "v-tab-item",
          { key: "tab-item-" + idx },
          [
            _vm._t(
              "content-" + idx,
              [
                _vm._t(
                  "content",
                  [_vm._v(" " + _vm._s(_vm.placeHolderText) + " ")],
                  { tab: tab }
                )
              ],
              { tab: tab }
            )
          ],
          2
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }